module.exports = __webpack_public_path__ + "components/intersport-discount-page/promo-article/static/article-image@2-43ef7c8e877918e62e0a16a953ef17ba.jpg";